// extracted by mini-css-extract-plugin
module.exports = {"root":"CalendarPopup_root__vWR_B","wrapper":"CalendarPopup_wrapper__xayJv","iconWrapper":"CalendarPopup_iconWrapper__VBK_T","icon":"CalendarPopup_icon__G8QKL"};